<template>
  <div>
    <div>
      <div class="table-wrap">
        <el-table
          v-loading="loading"
          :data="pageData.list"
          border
          style="width: 100%">
          <el-table-column
            prop="项目"
            label="项目"
            width="180">
            <template slot-scope="scope">
              <el-tooltip effect="dark" :content="scope.row['项目']" placement="bottom">
                <span class="project-name">{{scope.row['项目']}}</span>
              </el-tooltip>
            </template>
          </el-table-column>
          <el-table-column
            prop="姓名"
            label="姓名"
            width="180">
          </el-table-column>
          <el-table-column
            prop="职位"
            label="职位"
            width="180">
          </el-table-column>
          <el-table-column
            prop="项目数"
            label="项目数"
            width="100">
          </el-table-column>
          <el-table-column
            prop="管辖小区域数"
            label="管辖小区域数"
            width="100">
          </el-table-column>
          <el-table-column
            prop="催费任务户数"
            label="催费任务户数"
            width="100">
          </el-table-column>
          <el-table-column
            prop="抽检任务户数"
            label="抽检任务户数"
            width="100">
          </el-table-column>
          <el-table-column
            prop="实际抽检户数"
            label="实际抽检户数"
            width="100">
          </el-table-column>
          <el-table-column
            prop="抽检率"
            label="抽检率（%）"
            width="110">
            <template slot-scope="scope">
              <span v-if="scope.row['抽检率']>=100" style="color: rgb(21 145 6);font-weight: bold;">{{scope.row['抽检率']}}</span>
              <span v-if="scope.row['抽检率']<100" style="color: #ff3d00;font-weight: bold;">{{scope.row['抽检率']}}</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="抽检次数"
            label="抽检次数"
            width="110">
          </el-table-column>
          <el-table-column
            prop="平均时长"
            label="平均时长（秒）"
            width="110">
          </el-table-column>
          <el-table-column
            label="备注">
          </el-table-column>
        </el-table>
      </div>
      <div class="pagination-wrap">
        <el-pagination background layout="prev, pager, next" :total="pageData.total*1"
         :page-size="pageData.pageSize*1" :current-page="pageData.page*1"
         @current-change="pageChange"></el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import Track from "../../../../../assets/js/trackHttp";
import moment from "moment";
import {CommonHelp} from "../../common/CommonHelp";

export default {
  name: "TaskRecordList",
  inject:['where','reginWhere'],
  data(){
    return{
      pageData: {
        list: [],
        total: 0,
        pageSize: 15,
        page: 1,
      },
      all_count:0,
      from_data:{},
      dialogVisible:false,
      tree_obj:null,
      loading: false,
    }
  },
  mounted() {
    this.pageChange(1)
    // this.getAjaxCount()
  },
  watch:{
    "reginWhere.type_id":function (n,o) {
      this.pageChange(1);
    },
    "reginWhere.project_region":function (n,o) {
      this.pageChange(1);
    },
    "reginWhere.project_name":function (n,o) {
      this.pageChange(1);
    },
    "where.day_time":function (n,o) {
      this.pageChange(1);
    },
    "where.start_time":function (n,o) {
      this.pageChange(1);
    },
    "where.user_name":function (n,o) {
      this.pageChange(1);
    },
    "where.position_id":function (n,o) {
      this.pageChange(1);
    },
  },
  methods:{
    pageChange(i) {
      const that=this;
      that.pageData.page = i
      CommonHelp.debounce(()=>{
        that.getList()
      },500,that)

    },
    getList() {
      const that = this;
      that.loading = true;
      // let where = ERP.reJson(that.where);
      let start_time = that.reginWhere.start_time ?  that.reginWhere.start_time : moment(new Date()).format("YYYYMMDD");
      let end_time = that.reginWhere.end_time ?  that.reginWhere.end_time : moment(new Date()).format("YYYYMMDD");
      let where = {
        ...that.where,
        project_ids:that.reginWhere.project_ids,
        project_regin: that.reginWhere.project_region,
        project_id:that.reginWhere.project_name,
        project_type:that.reginWhere.type_id,
      }

      // console.log('where', where);

      // 请求
      Track.post('logger/ExpeditingInspection/getUserList2', {...where, page: that.pageData.page,page_size: that.pageData.pageSize}, res => {
        that.loading = false;
        // console.log('请求结果', res);
        if (res.code) {
          that.pageData  = res.data;
        }
      })
      //
    },
  }
}
</script>

<style lang="scss" scoped>
@import "../../common";

.m-2{
  width: 150px;
}
.ti {
  margin: 1%;
  width: 98%;
}

.text1 {
  text-align: center;
}

.pages {
  margin-top: 2%;
  margin-right: 3%;
  text-align: right;
}

.search {
  margin-top: 0.2%;
  width: 20%;
  margin-bottom: 1.5%;
}

.text2 {
  color: rgb(250, 248, 248);
}

.kuan {
  width: 10%;
}

.zhanwu {
  text-align: center;
  color: rgb(207, 205, 205);
  font-size: 20px;
  margin-top: 3%;
}

.d-flex {
  display: flex;
}

.d-flex-left {
  margin-right: 10px;
  border-right: 1px solid #eee;
  padding-right: 10px;
}

.d-flex-right {
  flex: 1;
  margin: 30px;
  width: calc( 100% - 10px );
  overflow-y: scroll;
  height: calc( 100vh - 150px );

  .header{
    padding-top: 5px;
    padding-bottom: 10px;
    position: sticky;
    top: 0;
    left: 0;
    right: 0;
    z-index: 10;
    background-color: #FFFFFF;
  }

  .btn-item {
    margin-top: 10px;
    margin-right: 30px;
  }

  >>>.el-tabs__item{
    color: black;
  }
}
.view-file-win{
  height: 60vh;
  overflow-y: scroll;
  .main-log{
    margin: 10px 20px;
  }
}
.header-btn2{
  .btn-item{
    margin: 10px 20px;
  }
}
.pagination-wrap {
  text-align: center;
  justify-content: center;
  margin-top: 15px;
  margin-bottom: 15px;
  display: flex;
}
.project-name{
  width: 150px;
  overflow-x: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
</style>



// WEBPACK FOOTER //
// src/components/Admin/Butler/components/taskrecord/TaskRecordList.vue